import _ from 'lodash';
import React from 'react';
import statusOptions from 'containers/request/RequestList/statusOptions';

const RenderOptions = () => {
  return _.map(statusOptions, option => {
    const title = option.title.toLowerCase();
    return (
      <option value={option.id} key={option.id}>
        {title}
      </option>
    );
  });
};

export default RenderOptions;



// WEBPACK FOOTER //
// ./src/containers/request/RequestList/RenderOptions.js